import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div className="home-page">
      <div className="home-content">
        <h1>Witaj w systemie zarządzania obligacjami!</h1>
        <div className="cta-section">
          <Link to="/obligacje" className="cta-button">
            Przejdź do obligacji
          </Link>
        </div>
      </div>
    </div>
  );
} 